import { useEffect } from "react";
import { useAuthState } from "@/store/auth";
import { useGetVisitsQuery } from "@/gqlhooks/visit/useGetVisitsQuery";
import { useScrollRefresh } from "@/components/shared/scroll-content/scroll-refresh-context";
import { addYears, startOfYesterday } from "date-fns";
import { formatDate } from "@/lib/helpers/date";
import { SortEnum, VisitSortByEnum } from "@/__generated__/graphql";

const VISIT_PER_PAGE = 20;

export const useVisitHistory = () => {
  const clientId = useAuthState((state) => state.data.userInfo.id);
  const { refreshing, setRefreshing } = useScrollRefresh();
  // Need this policy to make refreshing work
  const historyQuery = useGetVisitsQuery({
    skip: !clientId,
    fetchPolicy: "cache-and-network",
    variables: {
      filters: {
        clientId: [clientId],
        from: formatDate(addYears(startOfYesterday(), -1)),
        to: formatDate(startOfYesterday()),
        limit: VISIT_PER_PAGE,
        offset: 0,
        sortBy: [VisitSortByEnum.ServiceDate],
        sort: [SortEnum.Desc],
      },
    },
  });
  const isEmpty = historyQuery.list.length === 0 && !historyQuery.loading;
  useEffect(() => {
    if (refreshing) {
      historyQuery.refetch().then(() => {
        setRefreshing(false);
      });
    }
  }, [refreshing]);
  return {
    isEmpty,
    historyQuery,
  };
};
